/** Simulation rate. Changing it changes feel everywhere — tune weapons/movement in seconds, not ticks. */
export const TICK_RATE = 30;
export const TICK_DT = 1 / TICK_RATE;
export const TICK_MS = 1000 / TICK_RATE;

/** World units are pixels of the art. Tiles are 16×16. */
export const TILE_SIZE = 16;

/** Converts seconds to whole ticks (at least 1). */
export const ticks = (seconds: number): number => Math.max(1, Math.round(seconds * TICK_RATE));

/** A player's input bits (`PlayerInput.buttons`): the sim reads them, clients and the load test's fake humans send them. */
export const Button = {
  Up: 1 << 0,
  Down: 1 << 1,
  Left: 1 << 2,
  Right: 1 << 3,
  Fire: 1 << 4,
  Reload: 1 << 5,
  /** The right mouse button off the UI: a gun's second fire (the Mecha Suit's rockets, ADR-0096). */
  Alt: 1 << 6,
  /**
   * SPACE at a washing line's end, a ladder or a sunflower (ADR-0198): on; on a line again, off. A press, one tick's bit:
   * the client sets it only when SPACE goes to them (`GameSession.interact`).
   */
  Board: 1 << 8,
} as const;
